import { createSelector } from 'reselect'

const selectContactOption = state => state.contactoptions

const selectContactOptions = createSelector(
  selectContactOption,
  contactoptions => contactoptions.contactoptions
)

const selectContactOptionsFetching = createSelector(
  selectContactOption,
  contactoptions => contactoptions.isFetching
)

const selectDisplayComponent = createSelector(
  selectContactOption,
  contactoptions => contactoptions.displayComponent
)

export {
  selectContactOptions,
  selectContactOptionsFetching,
  selectDisplayComponent
}



// WEBPACK FOOTER //
// ./src/containers/ContactUsModal/selectors.js